import { Controller } from "@hotwired/stimulus";

/**
 * BrowserHistoryController can be used to update the browser history.
 * This is useful when you want the URL to reflect
 * the current state of the page even when using turbo frames, which
 * cannot natively do this as of turbo-rails 0.5.12
 *
 * @example <caption>Basic usage with a search form that updates a turbo frame.</caption>
 *
 * <%= form_tag(search_path,
 *       method: :get,
 *       data: {
 *         turbo_frame: 'search_results',
 *         controller: 'browser-history',
 *         action: 'submit->browser-history#formAdvance'
 *       }
 * ) do %>
 *   <%= text_field_tag :q, params[:q] %>
 *   <%= submit_tag "Search" %>
 * <% end %>
 *
 * <%= turbo_frame_tag 'search_results' do %>
 *   <!-- Search results content -->
 * <% end %>
 *
 */

export default class extends Controller {
  /**
   * Advances the browser URL when a form is submitted.
   */
  formAdvance(event) {
    const form = event.target;
    const formData = new FormData(form);
    const params = new URLSearchParams(formData);
    const url = `${form.action}?${params}`;

    history.pushState({}, "", url);
  }
}
